import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { confirmable, createConfirmation } from "react-confirm";

type ConfirmationProps = {
  okLabel?: string;
  cancelLabel?: string;
  title?: string;
  confirmation?: string;
  show?: boolean;
  proceed: (value: boolean) => void;
  enableEscape?: boolean;
};

const Confirmation = ({
  okLabel = "OK",
  cancelLabel = "Cancel",
  title = "Confirm",
  confirmation,
  show,
  proceed,
  enableEscape = true,
}: ConfirmationProps) => {
  return (
    <div className="static-modal">
      <Modal
        animation={false}
        show={show}
        className="app-confirmation-modal"
        backdropClassName="app-confirmation-backdrop"
        onHide={() => proceed(false)}
        backdrop={enableEscape ? true : "static"}
        keyboard={enableEscape}
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-line" }}>
          {confirmation}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => proceed(false)}>{cancelLabel}</Button>
          <Button
            className="button-l"
            variant="primary"
            onClick={() => proceed(true)}
          >
            {okLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

type ConfirmationBoxOptions = {
  title?: string;
  enableEscape?: boolean;
};

type ConfirmationRequest = {
  confirmation: string;
  okLabel: string;
  cancelLabel: string;
  title?: string;
  enableEscape?: boolean;
};

const confirm = createConfirmation(confirmable(Confirmation)) as unknown as (
  props: ConfirmationRequest
) => Promise<boolean>;

const ConfirmationBox = (
  confirmation: string,
  proceedLabel = "OK",
  cancelLabel = "cancel",
  options: ConfirmationBoxOptions = {}
): Promise<boolean> => {
  return confirm({
    confirmation,
    okLabel: proceedLabel,
    cancelLabel,
    ...options,
  });
};

export { Confirmation };
export default ConfirmationBox;
